"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComplexProductcard = ComplexProductcard;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _productImage = require("../../fuse-product-image/src/product-image");
var _promoIdentifier = require("../../fuse-promo-identifier/src/promo-identifier");
var _rating = require("../../fuse-rating/src/rating");
var _colourSwatch = _interopRequireDefault(require("./colour-swatch"));
var _config = require("./config");
var _skeletonCard = _interopRequireDefault(require("./skeleton-card"));
var _styledProductCard = require("./styled-product-card");
var _excluded = ["catalogueId", "title", "brand", "productUrl", "isSkeleton", "image", "price", "sfl", "stars", "swatches", "promotionIdentifier", "dataTestId", "className"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var useMemo = _react["default"].useMemo,
  useCallback = _react["default"].useCallback,
  useState = _react["default"].useState;
var propTypes = {
  catalogueId: _propTypes["default"].string,
  title: _propTypes["default"].string,
  brand: _propTypes["default"].string,
  productUrl: _propTypes["default"].string,
  isSkeleton: _propTypes["default"].bool,
  image: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    altText: _propTypes["default"].string,
    isAltReal: _propTypes["default"].bool,
    disabledLazy: _propTypes["default"].bool,
    fetchPriority: _propTypes["default"].oneOf(['low', 'auto', 'high'])
  }),
  price: _propTypes["default"].shape({
    current: _propTypes["default"].number,
    showCurrentPriceFrom: _propTypes["default"].bool,
    previous: _propTypes["default"].number,
    showPreviousPriceFrom: _propTypes["default"].bool,
    saving: _propTypes["default"].number,
    showSave: _propTypes["default"].bool,
    isEuro: _propTypes["default"].bool
  }),
  sfl: _propTypes["default"].shape({
    isSaved: _propTypes["default"].bool,
    saveCallback: _propTypes["default"].func
  }),
  stars: _propTypes["default"].shape({
    rating: _propTypes["default"].number,
    reviewText: _propTypes["default"].string
  }),
  swatches: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    imageSrc: _propTypes["default"].string
  })),
  promotionIdentifier: _propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    colour: _propTypes["default"].oneOf(['brand', 'black', 'featured', ''])
  }),
  dataTestId: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  catalogueId: '',
  title: '',
  brand: '',
  productUrl: '#',
  isSkeleton: false,
  image: {
    url: undefined,
    altText: undefined,
    isAltReal: false,
    disabledLazy: false,
    fetchPriority: undefined
  },
  price: {
    current: 0,
    showCurrentPriceFrom: false,
    previous: 0,
    showPreviousPriceFrom: false,
    saving: 0,
    showSave: true,
    isEuro: false
  },
  sfl: {
    saveCallback: null,
    isSaved: false
  },
  stars: {
    rating: 0,
    reviewText: ''
  },
  swatches: [],
  promotionIdentifier: {
    displayName: '',
    colour: 'black'
  },
  dataTestId: null,
  className: undefined
};
var isAltExists = function isAltExists(text) {
  return (typeof text === 'string' || text instanceof String) && text.length > 1;
};
function ComplexProductcard(_ref) {
  var catalogueId = _ref.catalogueId,
    title = _ref.title,
    brand = _ref.brand,
    productUrl = _ref.productUrl,
    isSkeleton = _ref.isSkeleton,
    image = _ref.image,
    price = _ref.price,
    sfl = _ref.sfl,
    stars = _ref.stars,
    swatches = _ref.swatches,
    promotionIdentifier = _ref.promotionIdentifier,
    dataTestId = _ref.dataTestId,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(sfl === null || sfl === void 0 ? void 0 : sfl.isSaved),
    _useState2 = _slicedToArray(_useState, 2),
    isSavePressed = _useState2[0],
    setSavePressed = _useState2[1];
  var imgAlt = !isAltExists(image === null || image === void 0 ? void 0 : image.altText) ? "Missing image for: ".concat(title) : image === null || image === void 0 ? void 0 : image.altText;
  var promoIdentifierSize = useMemo(function () {
    return {
      xxs: 'm2',
      m: 'm1',
      l: '1'
    };
  }, []);
  var textSize = useMemo(function () {
    return {
      xxs: 'm2',
      m: 'm1',
      l: '1'
    };
  }, []);
  var priceSize = useMemo(function () {
    return {
      xxs: 'xs',
      m: 'xs',
      l: 's'
    };
  }, []);
  var ratingSize = useMemo(function () {
    return {
      xxs: 'small',
      m: 'medium',
      l: 'large'
    };
  }, []);
  var sflIconSize = useMemo(function () {
    return {
      xxs: 'small',
      m: 'medium'
    };
  }, []);
  var handleSaveForLater = useCallback(function (e, _, newState) {
    e.preventDefault();
    setSavePressed(newState);
    sfl === null || sfl === void 0 || sfl.saveCallback(newState);
  }, [sfl === null || sfl === void 0 ? void 0 : sfl.saveCallback]);
  return isSkeleton ? /*#__PURE__*/_react["default"].createElement(_skeletonCard["default"], null) : /*#__PURE__*/_react["default"].createElement(_styledProductCard.CardContainer, _extends({
    className: className,
    "data-testid": dataTestId || 'fuse-complex-product-card-data-testid',
    "data-tagg-id": catalogueId || undefined
  }, props), /*#__PURE__*/_react["default"].createElement(_styledProductCard.StyledProductcard, {
    href: productUrl
  }, /*#__PURE__*/_react["default"].createElement(_productImage.ProductImage, {
    alt: imgAlt,
    src: image === null || image === void 0 ? void 0 : image.url,
    lazy: !(image !== null && image !== void 0 && image.disabledLazy),
    isAltReal: image === null || image === void 0 ? void 0 : image.isAltReal,
    sources: _config.imageSources,
    fetchPriority: image === null || image === void 0 ? void 0 : image.fetchPriority,
    border: "var(--border-width-xs) solid var(--color-global-grey300)"
  }), (promotionIdentifier === null || promotionIdentifier === void 0 ? void 0 : promotionIdentifier.displayName) && /*#__PURE__*/_react["default"].createElement(_promoIdentifier.PromoIdentifier, {
    text: promotionIdentifier.displayName,
    className: "fuse-complex-product-card__promo-identifier",
    color: promotionIdentifier.colour,
    dataTestId: "fuse-complex-product-card__promo-identifier",
    size: promoIdentifierSize
  }), /*#__PURE__*/_react["default"].createElement(_styledProductCard.SpaceUnderImage, null), /*#__PURE__*/_react["default"].createElement(_colourSwatch["default"], {
    swatches: swatches
  }), /*#__PURE__*/_react["default"].createElement(_styledProductCard.TaggstarWrapper, null, /*#__PURE__*/_react["default"].createElement(_styledProductCard.TaggstarContainer, null), /*#__PURE__*/_react["default"].createElement(_styledProductCard.BrandContainer, {
    type: "paragraph",
    size: textSize,
    tag: "span"
  }, brand), /*#__PURE__*/_react["default"].createElement(_styledProductCard.TitleContainer, {
    type: "heading",
    size: textSize,
    tag: "h3"
  }, title), /*#__PURE__*/_react["default"].createElement(_styledProductCard.StyledPrice, {
    price: (price === null || price === void 0 ? void 0 : price.current) || 0,
    headingTag: "h4",
    isEuro: price === null || price === void 0 ? void 0 : price.isEuro,
    prevPrice: price === null || price === void 0 ? void 0 : price.previous,
    saving: price === null || price === void 0 ? void 0 : price.saving,
    showCurrentFrom: price === null || price === void 0 ? void 0 : price.showCurrentPriceFrom,
    showPreviousFrom: price === null || price === void 0 ? void 0 : price.showPreviousPriceFrom,
    showSave: price === null || price === void 0 ? void 0 : price.showSave,
    size: priceSize
  }), stars !== null && stars !== void 0 && stars.rating ? /*#__PURE__*/_react["default"].createElement(_rating.Rating, {
    rating: stars === null || stars === void 0 ? void 0 : stars.rating,
    size: ratingSize,
    reviewLinkText: stars === null || stars === void 0 ? void 0 : stars.reviewText,
    dataTestId: "fuse-complex-product-card__rating"
  }) : null)), (sfl === null || sfl === void 0 ? void 0 : sfl.saveCallback) && typeof (sfl === null || sfl === void 0 ? void 0 : sfl.saveCallback) === 'function' && /*#__PURE__*/_react["default"].createElement(_styledProductCard.StyledSaveForLater, {
    isSaved: sfl === null || sfl === void 0 ? void 0 : sfl.isSaved,
    clickCallback: handleSaveForLater,
    showLabel: false,
    "aria-pressed": isSavePressed,
    saveLabel: "Save for later ".concat(brand, " ").concat(title),
    savedLabel: "Saved ".concat(brand, " ").concat(title),
    iconSize: sflIconSize
  }));
}
ComplexProductcard.propTypes = propTypes;
ComplexProductcard.defaultProps = defaultProps;
var _default = exports["default"] = ComplexProductcard;